<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.collapse-arrow .feather-icon {
  transform: rotate(-180deg);
  transition: 0.3s transform ease-in-out;
  display: inline-block;
}

.collapsed .collapse-arrow .feather-icon {
  transform: rotate(0deg);
}
 input.text-uppercase {
      text-transform: uppercase;
  }
  ::-webkit-input-placeholder {            
      text-transform: none;
  }
  :-moz-placeholder {
      text-transform: none;
  }
  ::-moz-placeholder {            
      text-transform: none;
  }
  :-ms-input-placeholder {            
      text-transform: none;
  }
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      User Grader
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    
    <form  v-on:submit.prevent="postData">

    <div class="card-body">
      <div class="text-center">
      
        <img
          :src="lihat_foto  ? lihat_foto : '/img/avatars/2.jpeg'"
          style="width:120px"
          class="card-img-top img img-responsive rounded-circle elevation-2 border"
          alt="User Picture"
        />
        <div class="mt-2">
          <div class="upload-btn-wrapper">
            <button class="btn-upload">Unggah Gambar</button>
            <input type="file" name="myfile" @change="uploadImage($event)" />
          </div>
        </div>
      </div>
      
      <div class="card border-0 shadow p-2">        
        <div class="card-body">
            <div class="form-row">
              
              <div class="form-group col-md-6">
                <label for="name" class="font-weight-bold">Nama User Grader</label>
                <input
                  type="name"
                  class="form-control"
                  id="name"
                  placeholder="Masukkan nama Grader"
                  v-model="formData.name"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label for="" class="font-weight-bold">Instansi</label>
                <input type="text" v-model="formData.instansi" name="" placeholder="Masukkan Nama Instansi" id="" class="form-control">
              </div>
             
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="email" class="font-weight-bold">Email Petugas</label>
                <input type="email" v-model="formData.email" class="form-control" id="email" placeholder="Masukkan Email" />
              </div>
              <div class="form-group col-md-6">
                <label for="no_telp" class="font-weight-bold">Nomor Telepon</label>
                <input
                  v-model="formData.noTelephone"
                  type="number"
                  class="form-control"
                  id="no_telp"
                  placeholder="Masukkan Nomor Telepon"
                />
              </div>
             
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="usename" class="font-weight-bold">Username</label>
                <input type="text" class="form-control" id="usename" v-model="formData.username" placeholder="Username Petugas" />
              </div>
              <div class="form-group col-md-6">
                <label for="pass" class="font-weight-bold">Password</label>
                <input type="password" class="form-control" v-model="formData.password" id="pass" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="usename" class="font-weight-bold">Bank</label>
                <input type="text" class="form-control text-uppercase" id="usename" placeholder="Masukkan Nama Bank" v-model="formData.namaBank"/>
              </div>
              <div class="form-group col-md-6">
                <label for="pass" class="font-weight-bold">No. Rekening</label>
                <input type="text" class="form-control" id="pass" placeholder="Masukkan No. Rekening" v-model="formData.noRekening"/>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="pass" class="font-weight-bold">NPWP</label>
                <input type="text" class="form-control" placeholder="Masukkan NPWP" id="pass" v-model="formData.npwp"/>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="usename" class="font-weight-bold">Alamat</label>
                <textarea name="" id="" cols="20" rows="10" v-model="formData.alamat" class="form-control"></textarea>                
              </div>
            </div>
            <div class="form-row">
              <CCol sm="12">
                <label for class="font-weight-bold">Status</label>
                <br />
                <div class="d-flex align-items-center">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input 
                     type="radio" 
                     class="custom-control-input" 
                     name="customRadio" 
                     id="aktif" 
                     value="1"
                     v-model="formData.status"
                    />
                    <label class="custom-control-label" for="aktif">Aktif</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input 
                     type="radio" 
                     class="custom-control-input" 
                     name="customRadio" 
                     id="tidak_aktif" 
                     value="0"
                     v-model="formData.status"
                    />
                    <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                  </div>
                </div>
              </CCol>
            </div>
        </div>
      </div>
     
      
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3">
        <Button class="btn btn-md btn-success px-4 py-2" style="float:right" type="submit" color="success">Simpan</Button>
        <br>
    </div>
    </form>

  </div>
</template>
<script>

import {MasterTC} from '@/mixins/master/MasterTC'
import {UploadImage} from '@/mixins/UploadImage'
import {AlertUtils} from '@/mixins/AlertUtils'
import UserGraderService from '@/services/sertifikasi/user-grader.service';

export default {
  mixins : [
      MasterTC,
      UploadImage,
      AlertUtils
  ],
  data: function() {
    return {
      lihat_foto : null,
      formData: {
          name: "",
          npwp: "",
          username: "", 
          email: "",
          noTelephone: "",
          password: "",
          alamat: "",
          status : "",
          instansi: "",
          namaBank : "",
          noRekening : "",
          foto: null
      },
  
    };
  },
  mounted() {
    document.getElementById("name").onkeypress = function (e) {
      var chr = String.fromCharCode(e.which);
      if ("qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM., ".indexOf(chr) < 0) return false;
    };
   
    this.getAllTestCenter();
  },
  methods : {
    postData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var formData = this.formData;
      if (typeof formData.foto === "string") {
        delete formData.foto
      }
      if (formData.foto === null) {
        delete formData.foto
      }
      UserGraderService.postUserGrader(formData)
      .then(response => {
        // comment console console.log(response);
        loader.hide();
        this.alertSuccess();
        if(this.formData.status == 1) {
          this.$router.push({ path: "/user-manajemen/user-grader-aktif" });
        } else {
          this.$router.push({ path: "/user-manajemen/user-grader-tidak-aktif" });
        }
      }).catch(error => {
        // comment console console.log(error);
        loader.hide();
        this.alertError(error.response.data.message);
      })
    }
  }
 
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>